import { render, staticRenderFns } from "./exam-view.vue?vue&type=template&id=779117d1"
import script from "./exam-view.vue?vue&type=script&lang=js"
export * from "./exam-view.vue?vue&type=script&lang=js"
import style0 from "./exam-view.vue?vue&type=style&index=0&id=779117d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports